import { useState } from 'react'
import { OVERVIEW_TAB } from '@constants/tournamentConstants'
import TournamentLeaderboardTab from './TournamentLeaderboardTab'
import TournamentPrizesTab from './TournamentPrizesTab'
import TournamentRulesTab from './TournamentRulesTab'

const TABS = Object.values(OVERVIEW_TAB)

// Sub-tab bar inside a single tournament's detail screen. Plain local state
// (not persisted) is correct here — unlike TournamentsMenu's Current/History
// tab, TournamentDetail is freshly mounted every time a tournament is opened,
// so there's nothing to survive across a remount.
const TournamentOverviewTabs = ({ tournament, origin }) => {
  const [currentTab, setCurrentTab] = useState(TABS[0].KEY)
  const activeIndex = TABS.findIndex((tab) => tab.KEY === currentTab)

  const renderContent = () => {
    switch (currentTab) {
      case OVERVIEW_TAB.LEADERBOARD.KEY:
        return <TournamentLeaderboardTab tournament={tournament} origin={origin} />
      case OVERVIEW_TAB.PRIZES.KEY:
        return <TournamentPrizesTab tournamentId={tournament.id} rewardType={tournament.rewardType} />
      case OVERVIEW_TAB.RULES.KEY:
        return (
          <TournamentRulesTab
            type={tournament.type}
            timeFrom={tournament.timeFrom}
            timeTo={tournament.timeTo}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className="standard-normal-tournament-overview-outer-container">
      <div
        className="standard-normal-tournament-overview-tabs-container"
        style={{
          '--tournament-overview-tab-count': TABS.length,
          '--tournament-overview-tab-index': activeIndex,
        }}
      >
        {TABS.map((tab) => (
          <div
            key={tab.KEY}
            className={`standard-normal-tournament-overview-tab ${tab.KEY === currentTab ? 'standard-normal-tournament-overview-active-tab' : ''}`}
            onClick={() => setCurrentTab(tab.KEY)}
          >
            {tab.LABEL}
          </div>
        ))}
        <span className="standard-normal-tournament-overview-tab-indicator" aria-hidden="true" />
      </div>

      <div className="standard-normal-tournament-overview-content-container">{renderContent()}</div>
    </div>
  )
}

export default TournamentOverviewTabs
